var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useGroupStorage } from '../../../../../../AppClients';
import { accountEntityName, addAccountsToGroupBulkActionType, getAccountPermissions, } from '../../../../../../backend/features/accounts/shared';
import { allowCreateGroup, getAccountsManageFilter, getAccountsViewFilterNew, requireAnyOrgPermission, requireAnySystemPermission, } from '../../../../../../backend/features/permissions/shared';
import { showAccountImportDialog } from '../../../../../../ui/features/accounts/components/AccountsPanel/components/AccountImportDialog';
import { showGroupDetailsDialog } from '../../../../../../ui/features/groups/components/GroupsPanel/components/GroupDetailsDialog';
import { showGroupsDialog } from '../../../../../../ui/features/groups/components/GroupsPanel/components/GroupsDialog';
import { handleAddToOrganization } from '../../../../../../ui/features/organizations/components/OrganizationsPanel/utils/AccountTableActionHandlers/handleAddToOrganization';
import { useUserState } from '../../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { getFilterForBulkAction } from '../../../../../../utils';
import { DataTable, useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { beginExport } from '@juvare/platform-sdk-react/ui/components/EntityTable/entityExport';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useExportClient } from '@juvare/platform-sdk-react/ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import DomainAddOutlinedIcon from '@mui/icons-material/DomainAddOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAccountsTable } from '../../../hooks/useAccountsTable';
import { useDefaultAccountImportColumns } from '../../../hooks/useDefaultAccountImportColumns';
import { AccountsIManageSwitch, showAccountsIManageFilterName } from '../../AccountsIManageSwitch';
import { AccountSlideout } from './AccountSlideout';
import { showChangeAccountsStatusDialog } from './AccountStatusDialog';
export const AccountsList = ({ hideHeader, onExtendedAccountImportColumns, customAccountSlideoutMenuItems, customAccountSlideoutDetailsComponent, ariaSlideoutContentId, }) => {
    var _a, _b, _c, _d, _e, _f;
    const { t } = useContactManagementTranslation();
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const settings = useSelector(getSettings);
    const userState = useUserState();
    const [searchParams] = useSearchParams();
    const handleGroupByFilter = () => {
        var _a, _b, _c;
        const filter = (_c = (_b = (_a = dataTableProps.customBackendResponseData) === null || _a === void 0 ? void 0 : _a.storageClientRequest) === null || _b === void 0 ? void 0 : _b.filter) !== null && _c !== void 0 ? _c : [];
        if (filter.length > 0) {
            showGroupDetailsDialog({
                initialData: {
                    filterBased: true,
                    visibility: 'private',
                    criteria: { filters: filter !== null && filter !== void 0 ? filter : [] },
                },
                fullWidth: true,
                maxWidth: 'sm',
                title: t('panels.accounts.newGroupFilter', { count: filter.length }),
                onSubmit: (data) => groupStorageClient
                    .post({ action: 'create', data: data })
                    .then(() => showInfoSnackbar({
                    message: t('panels.accounts.groupCreated'),
                    autoHideDuration: 2000,
                }))
                    .catch(handleErrorDialog),
            });
        }
    };
    const showAccountsIManage = searchParams.get(showAccountsIManageFilterName) === 'true';
    const locationName = 'accounts-panel';
    const { dataTableProps, clearActiveRow, reload } = useAccountsTable({
        location: { name: locationName },
        useDataTableFunction: useDataTableUsingUrl,
        rowSelectionEnabled: true,
        onRowClick: () => undefined,
        showAccountSystemRoleFilter: 'quickFilter',
        showAccountStatusFilter: 'quickFilter',
        saveFilterLabel: t('panels.accounts.groupByFilter'),
        onSaveFilter: handleGroupByFilter,
        showAccountsIManage,
    });
    const appliedStorageFilters = (_c = (_b = (_a = dataTableProps.customBackendResponseData) === null || _a === void 0 ? void 0 : _a.storageClientRequest) === null || _b === void 0 ? void 0 : _b.filter) !== null && _c !== void 0 ? _c : [];
    if (showAccountsIManage) {
        appliedStorageFilters.push(...getAccountsManageFilter(userState));
    }
    else {
        appliedStorageFilters.push(...getAccountsViewFilterNew(userState));
    }
    const { allowCreate } = getAccountPermissions(settings, userState);
    const allowImport = requireAnySystemPermission(userState, 'import-accounts') && settings.accountsImportEnabled;
    /**
     * TODO: CNEO-5510 this hook still holds the old frontend import logic. Should be removed since backend import is being used now. Keeping it for
     * backwards compitability due to onExtendedAccountImportColumns callback. Should only use import setting here.
     * */
    let accountImportColumns = useDefaultAccountImportColumns();
    // TODO: CNEO-5510 Should be removed since import logic is defined in Account enitity onImport callback. Keeping it to for backwards compitability now.
    if (onExtendedAccountImportColumns) {
        accountImportColumns = onExtendedAccountImportColumns(accountImportColumns);
    }
    const showExportButton = requireAnySystemPermission(userState, 'export-accounts') && settings.accountsExportEnabled;
    const exportClient = useExportClient();
    const rowCount = dataTableProps.selectedRowIds && dataTableProps.selectedRowIds.length > 0
        ? dataTableProps.selectedRowIds.length
        : (_d = dataTableProps.filteredRowCount) !== null && _d !== void 0 ? _d : 0;
    const handleExportAll = () => {
        var _a, _b;
        beginExport(exportClient, accountEntityName, (_a = settings.accountsExportFormat) !== null && _a !== void 0 ? _a : 'csv', undefined, getAccountsViewFilterNew(userState), [
            {
                column: (_b = dataTableProps.sortColumnKey) !== null && _b !== void 0 ? _b : 'displayName',
                desc: dataTableProps.sortColumnDesc,
            },
        ]);
    };
    const groupStorageClient = useGroupStorage();
    const handleAddToNewGroup = () => {
        showGroupDetailsDialog({
            initialData: {
                filterBased: false,
                visibility: 'private',
                criteria: { filters: [] },
            },
            fullWidth: true,
            maxWidth: 'sm',
            title: t('panels.accounts.newGroupAccount', { count: rowCount }),
            onSubmit: (data) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const { id } = yield groupStorageClient.post({ action: 'create', data: data });
                    launchBulkAction({
                        type: addAccountsToGroupBulkActionType,
                        title: t('panels.groups.addingAccountsToGroup'),
                        params: {
                            groupId: id,
                            filter: getFilterForBulkAction(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds, appliedStorageFilters),
                        },
                        onClose: () => {
                            var _a;
                            (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                            reload();
                        },
                    });
                }
                catch (error) {
                    handleErrorDialog(error);
                }
            }),
        });
    };
    const handleAddToExistingGroup = () => {
        showGroupsDialog({
            excludeFilterBasedGroups: true,
            onSelect: (selectedGroupId) => {
                launchBulkAction({
                    type: addAccountsToGroupBulkActionType,
                    title: t('panels.groups.addingAccountsToGroup'),
                    params: {
                        groupId: selectedGroupId,
                        filter: getFilterForBulkAction(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds, appliedStorageFilters),
                    },
                    onClose: () => {
                        var _a;
                        (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                        reload();
                    },
                });
            },
        });
    };
    const handleChangeStatus = () => {
        showChangeAccountsStatusDialog({
            appliedStorageFilters,
            dataTableProps,
            onAfterSave: () => {
                var _a;
                (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                reload();
            },
        });
    };
    const generateTemplateCsv = () => {
        let csvTemplate = '';
        csvTemplate +=
            accountImportColumns
                .map((columnImport) => (columnImport.required ? `${columnImport.headerName}*` : columnImport.headerName))
                .join(',') +
                '\n' +
                accountImportColumns.map((columnImport) => '"' + columnImport.exampleValue + '"').join(',');
        return csvTemplate;
    };
    const handleExport = () => {
        var _a, _b;
        beginExport(exportClient, accountEntityName, (_a = settings.accountsExportFormat) !== null && _a !== void 0 ? _a : 'csv', dataTableProps.selectedRowIds, appliedStorageFilters, [
            {
                column: (_b = dataTableProps.sortColumnKey) !== null && _b !== void 0 ? _b : 'displayName',
                desc: dataTableProps.sortColumnDesc,
            },
        ]);
    };
    return (React.createElement(React.Fragment, null,
        !hideHeader && React.createElement(PageHeaderWithImage, { gradient: 'blue-base', title: t('panels.accounts.title') }),
        React.createElement(Box, { p: 4 },
            React.createElement(DataTable, Object.assign({}, dataTableProps, { customHeaderElement: !requireAnySystemPermission(userState, 'manage-accounts') &&
                    requireAnyOrgPermission(userState, 'manage-members') ? (React.createElement(AccountsIManageSwitch, null)) : undefined, mainAction: allowCreate || allowImport
                    ? {
                        icon: React.createElement(AddIcon, null),
                        label: t('panels.accounts.addAccount'),
                        'data-test': 'add-account-button',
                        menuItems: [
                            ...(allowCreate
                                ? [
                                    {
                                        label: t('panels.accounts.singleAccount'),
                                        'data-test': 'create-single-account-button',
                                        onClick: () => navigationContext.navigate(() => navigate('new', { state: { back: true } })),
                                    },
                                ]
                                : []),
                            ...(allowImport
                                ? [
                                    {
                                        label: t('panels.accounts.importCsvFile'),
                                        onClick: () => {
                                            showAccountImportDialog(t, generateTemplateCsv());
                                        },
                                        'data-test': 'import-csv-button',
                                    },
                                ]
                                : []),
                        ],
                    }
                    : undefined, globalActions: [
                    ...((_e = dataTableProps.globalActions) !== null && _e !== void 0 ? _e : []),
                    ...(showExportButton
                        ? [
                            {
                                icon: React.createElement(FileUploadOutlinedIcon, null),
                                label: t('panels.accounts.exportAll'),
                                onClick: handleExportAll,
                                'data-test': 'export-all-button',
                            },
                        ]
                        : []),
                ], localActions: [
                    ...((_f = dataTableProps.localActions) !== null && _f !== void 0 ? _f : []),
                    ...(showExportButton
                        ? [
                            {
                                icon: React.createElement(FileUploadOutlinedIcon, null),
                                label: t('panels.accounts.export'),
                                onClick: handleExport,
                                'data-test': 'export-button',
                            },
                        ]
                        : []),
                    ...(allowCreateGroup(userState)
                        ? [
                            {
                                icon: React.createElement(GroupAddOutlinedIcon, null),
                                label: t('panels.accounts.addToGroup'),
                                'data-test': 'add-to-group-button',
                                disabled: rowCount === 0,
                                menuItems: [
                                    {
                                        label: t('panels.accounts.newGroup'),
                                        onClick: handleAddToNewGroup,
                                        'data-test': 'new-group-button',
                                    },
                                    {
                                        label: t('panels.accounts.addToExistingGroup'),
                                        onClick: handleAddToExistingGroup,
                                        'data-test': 'existing-group-button',
                                    },
                                ],
                            },
                        ]
                        : []),
                    ...(requireAnySystemPermission(userState, 'manage-accounts')
                        ? [
                            {
                                icon: React.createElement(PublishedWithChangesIcon, null),
                                label: t('panels.accounts.changeStatus.changeStatusButton'),
                                onClick: handleChangeStatus,
                                'data-test': 'change-status-button',
                            },
                        ]
                        : []),
                    ...(settings.organizationsEnabled &&
                        (requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members'))
                        ? [
                            {
                                label: t('panels.accounts.addToOrganization'),
                                icon: React.createElement(DomainAddOutlinedIcon, null),
                                'data-test': 'toolbar-add-to-organization-button',
                                onClick: () => handleAddToOrganization(userState, t, rowCount, dataTableProps, appliedStorageFilters, reload),
                            },
                        ]
                        : []),
                ] }))),
        React.createElement(AccountSlideout, { accountId: dataTableProps.activeRowId, onClose: (changed) => {
                clearActiveRow();
                if (changed) {
                    reload();
                }
            }, ariaSlideoutContentId: ariaSlideoutContentId, customMenuItems: customAccountSlideoutMenuItems, customDetailsComponent: customAccountSlideoutDetailsComponent, accountListReload: reload })));
};
